import {
  trackAgentAssistRecommendationFailure,
  trackAgentAssistUsefulnessCopied,
  trackAgentAssistUsefulnessNotHelpful,
} from '../analytics';
import { useSelector } from 'react-redux';
import {
  extractSelectedTicketFromState,
  extractIncomingMessagesArray,
  extractLastIncomingMessage,
  getselectedConversationId,
  getConversationMoreTicketInfo,
  getSelectedTicketBrand,
  extractOutgoingMessagesArray,
} from '../../../../../extractFromState';
import { useMutation } from 'react-query';
import { handleError } from '../../../../../services/ErrorService/ErrorService';
import { returnToPreviousMacroWizardPath } from '../../../../../actions/searchActions';
import { useDispatch } from 'react-redux';
import { htmlToText } from '../../../../../util';
import { getSalesAgentAssistResponse } from '../api';
import { useCallback } from 'react';

export default function useAgentAssistSales() {
  const dispatch = useDispatch();
  const selectedTicket = useSelector(extractSelectedTicketFromState);
  const incomingMessages = useSelector(extractIncomingMessagesArray);
  const lastIncomingMessage = useSelector(extractLastIncomingMessage);
  const conversationId = useSelector(getselectedConversationId);
  const asinId = useSelector(getConversationMoreTicketInfo)?.asin;
  const initialContactId = useSelector(getConversationMoreTicketInfo)?.initialContactId;
  const productCategory = useSelector(getConversationMoreTicketInfo)?.productCategory;
  const productLink = useSelector(getConversationMoreTicketInfo)?.productLink;
  const simplrTicketNumber = useSelector(extractSelectedTicketFromState)?.simplrTicketNumber;
  const brand = useSelector(getSelectedTicketBrand);
  const outgoingMessages = useSelector(extractOutgoingMessagesArray);
  const mutation = useMutation(getSalesAgentAssistResponse, {
    onError(error) {
      const message = error.message;
      handleError({ error, customMessage: message, showPopup: true });
      dispatch(returnToPreviousMacroWizardPath());
      trackAgentAssistRecommendationFailure(message);
    },
  });
  const macroText = mutation.data?.response;

  const { mutate } = mutation;

  const request = useCallback(() => {
    mutate({
      channel: selectedTicket.communicationType,
      simplrAccountId: selectedTicket.simplrAccountPtrId,
      messageBody: incomingMessages.map(htmlToText),
      conversationId,
      asin_id: asinId,
      initialContactId,
      productCategory,
      productLink,
      simplrTicketNumber,
      brand: brand ?? 'None',
      outgoingMessages,
    });
  }, [
    incomingMessages,
    selectedTicket.communicationType,
    selectedTicket.simplrAccountPtrId,
    mutate,
    brand,
    outgoingMessages,
    simplrTicketNumber,
    conversationId,
    asinId,
    initialContactId,
    productCategory,
    productLink,
  ]);
  const trackNotHelpfulClick = () => trackAgentAssistUsefulnessNotHelpful(macroText, lastIncomingMessage.messageId);
  const trackCopyClick = () => trackAgentAssistUsefulnessCopied(macroText, lastIncomingMessage.messageId);

  return {
    ...mutation,
    request,
    macroText,
    trackNotHelpfulClick,
    trackCopyClick,
  };
}
